import { getImagesStaticUrl } from '../../helpers';
import { useUpgradeMembershipContext } from '../../utils/ContextProviders/UpgradeContext';
import type { BaseUpgradePageProps } from '../UpgradeRedesign';
import DesktopCards from './DesktopCards';
import MobileTable from './MobileTable';
import UpgradeButton from './UpgradeButton';
import UpgradeDisclaimer from './UpgradeDisclaimer';
import './styles.css';
import { CouponCodeField } from '../../components/CouponCodeField';

interface UpgradePageProps extends BaseUpgradePageProps {
  flags?: {
    displayAdditionalPerks?: boolean;
  };
  ldClient?: unknown;
}

const Upgrade = ({
  flags,
  onSubmitSubscription,
  getCouponContentKey,
  hCaptcha,
  couponProps,
}: UpgradePageProps) => {
  const { growthUpgrade } = useUpgradeMembershipContext();
  const { displayAdditionalPerks } = flags || {};
  const { variables } = growthUpgrade;
  return (
    <>
      <div id="content" className="siteContent">
        <div
          className="upgradeBackgroundBanner"
          style={{
            backgroundImage: `url(${getImagesStaticUrl(
              getCouponContentKey('upgradeBackgroundBannerImage', 'hero-desktop.png'),
            )})`,
          }}
        >
          <img
            className="backgroundBannerWave"
            src={getImagesStaticUrl(
              getCouponContentKey('backgroundBannerWaveImage', 'upgrade-wave.svg'),
            )}
            alt="background"
          />
        </div>
        <div className="upgradeRow upgrade-container" style={{ position: 'relative' }}>
          <div className="upgradeCol paddingNone">
            <div className="pageContent">
              <article className="page">
                <div className="upgradeConfirmationContainer">
                  <div className="head textCenter">{variables?.heading}</div>
                  <div className="subHead textCenter">{variables?.subheading}</div>
                  <DesktopCards
                    showAdditionalPerks={displayAdditionalPerks}
                    getCouponContentKey={getCouponContentKey}
                  />
                  <MobileTable
                    showAdditionalPerks={displayAdditionalPerks}
                    getCouponContentKey={getCouponContentKey}
                  />
                  <div className="upgradeCouponCode">
                    <CouponCodeField {...couponProps} />
                  </div>
                  <div className="acceptanceContainer">
                    <UpgradeDisclaimer />
                    <UpgradeButton
                      onClickUpgrade={onSubmitSubscription}
                      getCouponContentKey={getCouponContentKey}
                    >
                      {hCaptcha}
                    </UpgradeButton>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Upgrade;
